import styled from '@emotion/styled';
import { Colors } from '@utex/ui-kit';

export const Container = styled('div')`
  margin-bottom: 2rem;
  border-top: 1px solid ${Colors.ut.shadow10};
`;

export const Section = styled('div')`
  padding-bottom: 0.8rem;
  border-bottom: 1px solid ${Colors.ut.shadow10};
`;
